<template>
  <div>
    <h2 class="text-left alert" :class="[ removed ? 'alert-danger' : 'alert-success' ]">
      Review NSAIDS 
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[ removed ? 'glyphicon-plus' : 'glyphicon-remove' ]"></span>
      </a>
    </h2>

    <template v-if="!removed">
      <div class="text-left step-section">
        <h3 :class="isRemovedSubsection('annual_nsaids') ? 'subsection-disabled' : ''">
          <u>Annual NSAIDS</u>
          <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'annual_nsaids')">
            <span class="glyphicon" :class="isRemovedSubsection('annual_nsaids') ? 'glyphicon-plus' : 'glyphicon-remove'">
            </span>
          </a>
        </h3>
        <bar :chart-data="chartDataNsaidsSeason" :options="chartOptions" ref="annual_nsaids_chart"></bar>
      </div>

      <div class="text-left step-section">
        <h3 :class="isRemovedSubsection('review_period_to_date_nsaids') ? 'subsection-disabled' : ''">
          <u>Review period to-date NSAIDS</u>
          <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'review_period_to_date_nsaids')">
            <span class="glyphicon" :class="isRemovedSubsection('review_period_to_date_nsaids') ? 'glyphicon-plus' : 'glyphicon-remove'">
            </span>
          </a>
        </h3>
        <bar :chart-data="chartDataPeriodToDate" :options="chartOptions" ref="period_nsaids_chart"></bar>
      </div>

      <div class="text-left step-section">
        <h3 :class="isRemovedSubsection('top_products_by_total_amount') ? 'subsection-disabled' : ''">
          <u>Top products by total amount used (NSAID in mg/kg by season)</u>
          <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'top_products_by_total_amount')">
            <span class="glyphicon" :class="isRemovedSubsection('top_products_by_total_amount') ? 'glyphicon-plus' : 'glyphicon-remove'">
            </span>
          </a>
        </h3>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Product</th>
              <th>{{ seasonStartYear -4 }} / {{ seasonStartYear -3 }}</th>
              <th>{{ seasonStartYear -3 }} / {{ seasonStartYear -2 }}</th>
              <th>{{ seasonStartYear -2 }} / {{ seasonStartYear -1 }}</th>
              <th>{{ seasonStartYear -1 }} / {{ seasonStartYear }}</th>
              <th>{{ seasonStartYear }} / {{ seasonStartYear + 1 }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rv, index) in model.CHARTS.nsaid_five_years_products_usage" :key="index">
              <td class="text-left">{{ rv["product"] }}</td>
              <td class="text-left">{{ rv["season_start_4"] }}</td>
              <td class="text-left">{{ rv["season_start_3"] }}</td>
              <td class="text-left">{{ rv["season_start_2"] }}</td>
              <td class="text-left">{{ rv["season_start_1"] }}</td>
              <td class="text-left">{{ rv["season_start"] }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="text-left step-section">
        <dl class="dl-horizontal">
          <dt>Key Points</dt>
          <dd>{{ model.nsaid_actions || '-'}}</dd>

          <dt>Actions</dt>
          <dd>{{ model.nsaid_keypoints || '-'}}</dd>
        </dl>
      </div>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'
import Bar from '../../charts/Bar'

export default {
  mixins: [ mixin ],
  props: ['model'],
  components: {
    Bar,
  },
  data() {
    return {
      stepName: 'ReviewNsaids',
    }
  },
  computed: {
    chartOptions: function () {
      return {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: 'mg/kg'
            }
          }]
        }
      }
    },
    chartDataNsaidsSeason: function () {
      return {
        labels: Array.from(new Set(this.model.CHARTS.nsaids_season.map(row => row['season']))),
        datasets: [
          {
            label: "This Farm",
            backgroundColor:  "#3e95cd",
            data: this.model.CHARTS.nsaids_season.filter(row => row['name'] == 'client').map(row => row['mg_kg_nsaid']),
          },
          {
            label: "Region",
            backgroundColor:  "#c45850",
            data: this.model.CHARTS.nsaids_season.filter(row => row['name'] == 'region').map(row => row['mg_kg_nsaid']),
          },
        ],
      }
    },
    chartDataPeriodToDate: function () {
      return {
        labels: Array.from(new Set(this.model.CHARTS.nsaids_period_to_date.map(row => row['period']))),
        datasets: [
          {
            label: "This Farm",
            backgroundColor:  "#3e95cd",
            data: this.model.CHARTS.nsaids_period_to_date.filter(row => row['name'] == 'client').map(row => row['nsaid_mg_kg']),
          },
          {
            label: "Region",
            backgroundColor:  "#c45850",
            data: this.model.CHARTS.nsaids_period_to_date.filter(row => row['name'] == 'region').map(row => row['nsaid_mg_kg']),
          },
        ],
      }
    },
  },
};
</script>
